var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"configure-location"},[_c('header-mobile-page',{attrs:{"label":"Configure Location Screen"}}),_c('geofence-configure-screen',{attrs:{"mode":_vm.mode,"named-location-id":_vm.locationId,"location-from-history":_vm.locationFromHistory}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }